var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showRequirements
    ? _c(
        "div",
        {
          staticClass:
            "w-full bg-black text-white p-4 mb-3 md:mb-12 flex flex-wrap border-l-24 border-red",
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "w-full md:w-1/2 flex flex-wrap md:justify-end" },
            [
              !_vm.contractOverride
                ? [
                    _vm.hasSignedContract
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center text-white text-lg mr-8",
                          },
                          [
                            _c("span", { staticClass: "mr-2 text-base" }, [
                              _vm._v("Collaborator Agreement"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "24",
                                  height: "25",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                },
                              },
                              [
                                _c("defs", [
                                  _c("path", {
                                    attrs: {
                                      id: "a",
                                      d: "M0 .478h23.523V24H0z",
                                    },
                                  }),
                                ]),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      fill: "none",
                                      "fill-rule": "evenodd",
                                    },
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          transform: "translate(0 .273)",
                                        },
                                      },
                                      [
                                        _c(
                                          "mask",
                                          { attrs: { id: "b", fill: "#fff" } },
                                          [
                                            _c("use", {
                                              attrs: { "xlink:href": "#a" },
                                            }),
                                          ]
                                        ),
                                        _c("path", {
                                          attrs: {
                                            d: "M18.414 18.892c-3.673 3.674-9.631 3.674-13.306 0a9.408 9.408 0 0 1 0-13.306 9.409 9.409 0 1 1 13.306 13.306M3.444 3.922c-4.592 4.593-4.592 12.04 0 16.633 4.594 4.594 12.04 4.594 16.634 0 4.593-4.593 4.593-12.04 0-16.633s-12.04-4.593-16.633 0",
                                            fill: "#FFF",
                                            mask: "url(#b)",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c("path", {
                                      attrs: {
                                        d: "M10.585 18.392c-.28 0-.552-.1-.766-.284L5.702 14.57a1.176 1.176 0 0 1 1.533-1.784l3.109 2.671 5.143-7.715a1.176 1.176 0 1 1 1.958 1.305l-5.882 8.82a1.171 1.171 0 0 1-.978.525",
                                        fill: "#FFF",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "flex items-center mr-8" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "text-white text-base mr-2",
                                attrs: {
                                  to: `/events/${_vm.eventId}/contracts/${_vm.contractId}/sign`,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    Collaborator Agreement\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "24",
                                  height: "25",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M12 22.5c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm0 2c-6.627 0-12-5.373-12-12S5.373.5 12 .5s12 5.373 12 12-5.373 12-12 12z",
                                    fill: "#FFF",
                                    "fill-rule": "evenodd",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pr-4 mb-3 md:mb-0 w-full md:w-1/2" }, [
      _c("p", [
        _vm._v(
          "IMPORTANT: You must complete the Collaborator Agreement before submitting your event."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }